import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import { useShallowSelector } from "../../../../hooks/useShallowSelector";

interface ToolbarProps {
  handleSendButtonClick: () => void;
  classes: Record<string, string>;
}

const ToolbarComponent: React.FC<ToolbarProps> = ({
  handleSendButtonClick,
  classes,
}) => {
  const selectedBookings = useShallowSelector(
    (state) => state.bookings.selectedBookings
  );

  return (
    <Grid
      container
      item
      className={classes.selectedBookingsAndActionButtonGrid}
    >
      <Grid
        item
        container
        xs={12}
        md={10}
        className={classes.selectedBookingsGrid}
      >
        {selectedBookings.length > 0 ? (
          <Typography className={classes.selectedBookingsText}>
            {selectedBookings.length > 1
              ? `${selectedBookings.length} units are selected`
              : "1 unit is selected"}
          </Typography>
        ) : (
          <Typography className={classes.selectedBookingsText}>
            No unit is selected
          </Typography>
        )}
      </Grid>
      <Grid item container xs={12} md={2} className={classes.actionButtonGrid}>
        <Button
          className={`sendButton`}
          variant="contained"
          onClick={handleSendButtonClick}
          disabled={selectedBookings.length === 0}
        >
          <span id="buttonText">Send</span>
        </Button>
      </Grid>
    </Grid>
  );
};

export default ToolbarComponent;
